module.exports = __webpack_public_path__ + "img/sand-clock.93c703c7.svg";